package com.binayshaw7777.kotfolio.utils

object Constants {
    const val RESUME_URL = "https://drive.google.com/file/d/1cDrT_MfkUja5_xXnK5JvD5esT7MwFara/view?usp=sharing"
    const val LINKEDIN_URL = "https://www.linkedin.com/in/binayshaw7777/"
    const val GITHUB_URL = "https://github.com/binayshaw7777"
    const val TWITTER_URL = "https://twitter.com/binayplays7777"
    const val BEHANCE_URL = "https://www.behance.net/GAMIX7"
    const val MEDIUM_URL = "https://medium.com/@binayshaw7777"
    const val MAIL_TO = "mailto:binayshaw7777@gmail.com"
    const val PROJECT_READBUD_URL = "https://github.com/binayshaw7777/ReadBud"
    const val PROJECT_JUSTAP_URL = "https://github.com/binayshaw7777/JusTap"
    const val PROJECT_MEDIFY_URL = "https://github.com/binayshaw7777/Medify"
    const val PROJECT_PASSGENIE_URL = "https://github.com/binayshaw7777/PassGinie-Kobweb"
    const val PROJECT_PRESIN_URL = "https://github.com/binayshaw7777/Microsoft-Engage-2022-PresIN"

    const val HELLO_IM = "Hello I'm"
    const val BINAY_SHAW = "Binay Shaw."
    const val AND_NICE_TO_MEET_YOU = "and Nice to meet you!"
    const val RESUME = "Resume"

    const val ABOUT_ME_TEXT = "Binay is a versatile Software Developer proficient in both Android and iOS development. Additionally, he demonstrates a hands-on approach to crafting elegant User Interfaces, showcasing a talent for bug resolution and consistently delivering optimal results."
    const val ABOUT_ME_TITLE = "About me."

    const val EXPERIENCE_TITLE = "Work Experience."
    const val EXPERIENCE_SECTION_TEXT = "I’m a Software Developer Engineer, specializing in Android & Backend Development with "
    const val FIVE_MONTH = "5 months"
    const val OF_INTERNSHIP = " of Internship Experience."

    const val SKILLS_AND_TOOLS_TITLE = "Skills & Tools."

    const val PHOTOGRAPH_TITLE = "Sometimes I love to click."

    const val PROJECT_TITLE = "My Side Projects."
    const val PROJECT_SECTION_TEXT = "I really have a bad habit of creating projects over projects XD"
    const val PROJECT_REPOSITORIES_URL = "https://github.com/binayshaw7777?tab=repositories"
    const val MORE_ON_GITHUB = "More on GitHub."
}